import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer id="footer" className='footer'>
        <div className='copyright'>
            &copy; Copyright{' '}
            <strong>
                <span>HTZ Infoware Solutions</span>
            </strong>
            . All Right Reserved
        </div>
        <div className='credits'>
            Designed by <a href="#">HTZ</a>
        </div>
    </footer>
  )
}

export default Footer